export default __webpack_public_path__ + "static/media/46_2_0.1d04c14e.png";